<template>
  <textarea
    ref="textarea"
    :placeholder="placeholder"
    :value.prop="value"
    @input="update"
    @focus="$emit('input-focus', $event.target.value)"
    @blur="$emit('input-blur', $event.target.value)"
  ></textarea>
</template>

<script>
export default {
  name: 'BaseTextarea',
  props: {
    placeholder: {
      type: String
    },
    value: {
      type: String
    },
    vuelidate: {
      type: Object
    },
    autosize: {
      type: Boolean,
      string: false
    }
  },
  methods: {
    update($event) {
      console.log($event.target.value)
      this.vuelidate.$touch()
      this.$emit('input', $event.target.value)
    }
  }
}
</script>
